import React from "react";
import GitHubCalendar from "react-github-calendar";
import { Row } from "react-bootstrap";

function Github() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "30px" }}>
      <h1 className="project-heading" style={{ paddingBottom: "20px" }}>
        Days I <strong className="purple">Code</strong>
      </h1>
      <div className="github-calendar-container">
        <GitHubCalendar
          username="Muniraj132"
          blockSize={15}
          blockMargin={5}
          color="var(--color-primary)"
          fontSize={14}
        />
      </div>
    </Row>
  );
}

export default Github;
